const getHeaders = (i18n, showStatus) => (
  showStatus ? [
    {
      id: 'file_uplodad_remove_btn',
      label: i18n.remove,
      width: 10
    },
    {
      id: 'file_upload_file_name',
      label: i18n.fileName,
      width: 45
    },
    {
      id: 'file_upload_file_size',
      label: i18n.fileSize,
      width: 30
    },
    {
      id: 'file_upload_status',
      label: i18n.status,
      width: 15
    }
  ] :
    [{
      id: 'file_uplodad_remove_btn',
      label: i18n.remove,
      width: 10
    },
    {
      id: 'file_upload_file_name',
      label: i18n.fileName,
      width: 35
    },
    {
      id: 'file_upload_file_size',
      label: i18n.fileSize,
      width: 55
    }]
);

export default getHeaders;
